module.exports = __webpack_public_path__ + "static/media/LittleGiantSeriePG.c060ae72.png";